import './App.css';
import Navbar from './Components/Navbar';
import React, { useState } from 'react'
import { jsPDF } from "jspdf";
import Alert from './Components/Alert';



function App(props) {
  const [text, settext] = useState('');
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type
    })
    setTimeout(() => {
      setAlert(null);
    }, 1500);
  }

  function onChangetext(event) {
    settext(event.target.value);
  }

  function UpperCase() {
    if (text !== '') {
      settext(text.toUpperCase());
      showAlert("Converted to UpperCase!", "success");
    }
    else
      showAlert("Please enter text below!", "info");
  }

  function lowerCase() {
    if (text !== '') {
      settext(text.toLowerCase());
      showAlert("Converted to lowerCase!", "success");
    }
    else
      showAlert("Please enter text below!", "info");
  }

  function CapitalizeEachWord() {
    if (text !== '') {
      let text11 = text;
      text11 = text11.trim().split(" ");
      for (let index = 0; index < text11.length; index++) {
        let govind1 = text11[index];
        text11[index] = govind1[0].toUpperCase() + govind1.slice(1).toLowerCase() + " ";
      }
      settext(text11.join(''));
      showAlert("Converted to Capitalize Each Word!", "success");
    }
    else
      showAlert("Please enter text below!", "info");
  }


  function Sentensecase(){
    if (text !== ''){
      let text12 = text;
      text12 = text12.trim().split(". ");
      for (let index = 0; index < text12.length; index++) {
        let govind1 = text12[index];
        text12[index] = govind1[0].toUpperCase() + govind1.slice(1).toLowerCase() + ". ";        
      }  
      settext(text12.join(''));
      showAlert("Converted to Sentense case!", "success");
    }
    else
      showAlert("Please enter text below!", "info");
  }

  function tOOGLEcASE(){
    if (text !== ''){
      let text13 = text;
      text13 = text13.trim().split(". ");
      for (let index = 0; index < text13.length; index++) {
        let govind1 = text13[index];
        text13[index] = govind1[0].toLowerCase() + govind1.slice(1).toUpperCase() + ". ";        
      }  
      settext(text13.join(''));
      showAlert("Converted to Sentense case!", "success");
    }
    else
      showAlert("Please enter text below!", "info");
  }
  
  function Copytext() {
    if (text !== '') {
      navigator.clipboard.writeText(text);
      showAlert("Text Copied!", "success");
    }
    else
      showAlert("Please enter text below!", "info");
  }

  function ExportPdf() {
    if (text !== '') {
      var doc = new jsPDF();
      doc.text(text, 10, 10);
      doc.save("GoText.pdf");
      showAlert("Pdf Exported!", "success");
    }
    else
      showAlert("Please enter text below!", "info");
  }

  function RemoveExtraSpace() {
    if (text !== '') {
      settext(text.replace(/\s+/g, ' '));
      showAlert("Extra Space Removed!", "success");
    }

    else
      showAlert("Please enter text below!", "info");

  }

  function ClearText() {
    if (text !== '') {
      settext('');
      showAlert("Text Cleared!", "success");
    }

    else
      showAlert("Text Input is already empty!", "info");

  }

  // const [replac, setplace] = useState('');
  // function txtreplace(event){
  //   setplace(event.target.value);
  //   settext(text.replace(replac,"replace"));
  // }

  return (
    <>
      <Navbar />
      <Alert alert={alert} />
      <div class='container'>
        <h1 className='m-1'>Enter The Text Below...</h1>
        {/* <h2>{replace}</h2> */}
        <textarea showAlert={showAlert} class="form-control  mt-2 mb-2" id="exampleFormControlTextarea1" rows="6" onChange={onChangetext} value={text}></textarea>
        <button type="button" class="btn btn-primary m-1" onClick={UpperCase}>UPPERCASE</button>
        <button type="button" class="btn btn-primary m-1" onClick={lowerCase}>lowercase</button>
        <button type="button" class="btn btn-primary m-1" onClick={CapitalizeEachWord}>Capitalize Each Word</button>
        <button type="button" class="btn btn-primary m-1" onClick={Sentensecase}>Sentense case</button>
        <button type="button" class="btn btn-primary m-1" onClick={tOOGLEcASE}>tOOGLE cASE</button>
        <button type="button" class="btn btn-primary m-1" onClick={RemoveExtraSpace}>RemoveExtraSpace</button>
        <button type="button" class="btn btn-primary m-1" onClick={Copytext}>Copy Text</button>
        <button type="button" class="btn btn-primary m-1" onClick={ExportPdf}>Export to Pdf</button>
        <button type="button" class="btn btn-primary m-1" onClick={ClearText}>Clear Text</button>
        {/* <input type="text" class="form-control-sm p-1 m-1" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default" placeholder="Enter Text To Replace" onChange={txtreplace}/> */}
        <div>

          <h3>TextPreview</h3>
          <h4>{text.split(/\s+/).filter((element) => { return element.length !== 0 }).length} words and {text.length} characters</h4>
        </div>
      </div>
      <footer>Copyright © 2021. GoText.</footer>
    </>
  );
}

export default App;
